export default __webpack_public_path__ + "static/media/sobre.737af2cc.svg";